import React, { useState} from "react";
import { Input } from "antd";
import {
    Checkbox, FormControlLabel, Select,
    InputAdornment,
    IconButton
} from "@material-ui/core";

import "./styles.css";
import useStyles from "./styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
//const Option = { Select };
const { TextArea } = Input;



function InputBaseField({ id, placeholder, name, value, type, MaxLength, MinLength, onKeyPress, IsDisabled, onClick, onChange, after, InputRef,
    InputProps, restrictNegative, cardField, enablePasswordToggle, ...props }) {

    const onChangeEvent = (event) => {
        if (event.target.value.trim() === "" && event.target.value !== "") {
            return;
        }
        onChange(event);
    };
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    return (
        type === "password" ? (
                //<Input
                //    id={id}
                //    name={name}
                //    value={value}
                //    type={showPassword && enablePasswordToggle ? 'text' : 'password'}
                //    addonAfter={after}
                //    disabled={IsDisabled}
                //    placeholder={placeholder}
                //    onChange={onChangeEvent}
                //    className={useCamelCase ? "custom-input" : "custom-input"}
                //    autoComplete="off"
                //    maxLength={MaxLength}
                //    format={dateFormat}
                //    onKeyPress={onKeyPress}
                //    min={minDateTime}
                //    readOnly={readOnly ? readOnly : ""}
                //    onDrop={onDrop}
                //    onPaste={onPaste}
                //    {...props}
                //    suffix={
                //        enablePasswordToggle && (
                //            <InputAdornment position="end">
                //                <IconButton onClick={togglePasswordVisibility} edge="end">
                //                    {showPassword ? <VisibilityIcon style={{ paddingRight: "5px" }} /> : <VisibilityIcon style={{ paddingRight: "5px" }} />}
                //                </IconButton>
                //            </InputAdornment>
                //        )
                //    }
            ///>
            <Input
            style={{margin:'0'}}
                id={id}
                name={name}
                value={value}
                type={showPassword && enablePasswordToggle ? 'text' : 'password'}
                addonAfter={after}
                disabled={IsDisabled}
                placeholder={placeholder}
                onChange={onChangeEvent}
                className={cardField ? "custom-input-card" : "custom-input"}
                 autocomplete="one-time-code"
                maxLength={MaxLength}
                onKeyPress={onKeyPress}
                {...props}
                suffix={
                    enablePasswordToggle && (
                        <InputAdornment position="end">
                            <IconButton onClick={togglePasswordVisibility} edge="end">
                                {showPassword ? <VisibilityIcon style={{ paddingRight: "5px" }} /> : <VisibilityIcon style={{ paddingRight: "5px" }} />}
                            </IconButton>
                        </InputAdornment>
                    )
                }
            />
        ):
        <Input
            id={id}
            name={name}
            value={value}
            type={type}
            addonAfter={after}
            disabled={IsDisabled}
            placeholder={placeholder}
            onChange={onChangeEvent}
            className={cardField ? "custom-input-card" : "custom-input"}
            autocomplete="one-time-code"
            maxLength={MaxLength}
            onKeyPress={onKeyPress}
        />
    )
}
function SelectField({ id, name, value, options, placeholder, className, defualtValue, onChange, IsDisabled, ...props }) {

    const classes = useStyles();

    const onChangeEvent = (value) => {
        onChange(name, value);
    };

    return (
        <>
            <Select
                name={name}
                id={id}
                value={value}
                onChange={onChange}
                disabled={IsDisabled}
                className={className == false ? '' : classes.selectBaseInput}
                defaultValue={defualtValue}
                displayEmpty
            >

           
                {
                    options.map(option => <option value={option.value}>{option.label}</option>)
                }
            </Select>
        </>
    )
}
function TextareaField({ id, name, value, MaxLength, MinLength, placeholder, rowsMin, onChange, InputProps, Disabled, ...props }) {


    const onChangeEvent = (event) => {
        onChange(event);
    };

    return (
        <>

            <TextArea id={id}
                rows={4}
                placeholder={placeholder}
                maxLength={MaxLength}
                onChange={onChangeEvent}
                name={name}
                value={value}
                className="custom-input"
                disabled={Disabled}
                {...props}
            />

            {/* <TextareaAutosize
                id={id}
                className={classes.baseTextarea}
                rowsMin={rowsMin}
                placeholder={placeholder}
                onChange={onChangeEvent}
                name={name}
                value={value}
                maxLength={MaxLength}
                disabled={Disabled}
                inputProps={{ minlength: MinLength, autoComplete: "off", ...InputProps }}
                rows={5}
                {...props}

            /> */}

        </>
    );
}
function CheckboxField({ id, name, checked, label, labelPlacement, value, color, onChange, IsDisabled, ...props }) {


    const onChangeEvent = (event) => {
        if (onChange)
            onChange(event);
    };

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        disabled={IsDisabled}
                        color={color}
                        className="checkBoxBtn"
                        onChange={onChangeEvent}
                        name={name}
                        id={id}
                        checked={checked}
                        value={value}
                        {...props}

                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />

        </>
    );
}

export { InputBaseField, SelectField, CheckboxField, TextareaField };